import { z } from 'zod';
import { NOTIFICATION_TYPES, type NotificationType } from '../enums.js';
import { bulkIdsSchema } from './records.js';
import { paginationQuerySchema } from './common.js';

/**
 * Notifications.
 *
 * Strictly per-user, not per-organization: a notification is addressed to one
 * person, and there is no "team inbox". Every query is scoped by `userId` as
 * well as `organizationId`, so an admin cannot read a colleague's.
 */
export const listNotificationsQuerySchema = paginationQuerySchema.extend({
  /** Only the ones not yet read. */
  unreadOnly: z.stringbool().optional(),
});
export type ListNotificationsQuery = z.infer<typeof listNotificationsQuerySchema>;

export const markNotificationsReadSchema = bulkIdsSchema;
export type MarkNotificationsRead = z.infer<typeof markNotificationsReadSchema>;

export interface NotificationSummary {
  id: string;
  type: NotificationType;
  title: string;
  body: string | null;
  /** Deep link into the app; null when there is nothing to open. */
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationCounts {
  unread: number;
  /** Capped, so the badge shows "9+" rather than counting a thousand rows. */
  cappedAt: number;
}

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  MENTION: 'Mentioned you',
  ASSIGNMENT: 'Assigned to you',
  APPROVAL_REQUEST: 'Approval needed',
  APPROVAL_DECISION: 'Approval decided',
  TASK_DUE: 'Task due',
  WORKFLOW: 'Workflow',
  SYSTEM: 'System',
};

export const UNREAD_BADGE_CAP = 9;

export { NOTIFICATION_TYPES };
